var dot = ' ' + '\u{2022}' + ' ';
//var dot =  <span class="square-separator"></span>;
let selectedText = 'In Package' + dot;


// Handles edge case where product selections get messed up when user navigates to this page via the forward/back buttons in their browser.
// The solution is to simply reload the page
window.addEventListener("pageshow", function (event) {
  var historyTraversal = event.persisted || (typeof window.performance !== "undefined" && window.performance.navigation.type === 2);
  if (historyTraversal) {
    window.location.reload();
  }
});


// New product selected
$('input[type=radio].pp-product-select').click(function () {
  show_selected_products();
  update_summary();
});


// New product option selected (ie. silver/black, unlimited/limited tunes)
$('.pp-option-selector').on('change', function () {
  let product_id = $(this).data('product-id');
  let product = get_product_by_id(product_id);
  let variant = get_selected_variant(product, product_id);

  set_product_price(variant, product_id);


  // Select the product this option belongs to (which triggers jquery above)
  $('#' + product_id).prop("checked", true);
  $('#' + product_id).trigger('click');


  try {
    let image_id = variant['featured_image']['id'];
    update_image_for_product(product_id, image_id);
  } catch {
    // There's no image specifically for this variant, leave image as-is
  }

  update_summary();
});


// New quantity selected
$('.pp-quantity-selector').on('change', function () {
  let product_id = $(this).data('product-id');
  let product = get_product_by_id(product_id);


  // Select the product this option belongs to (which triggers jquery above)
  $('#' + product_id).prop("checked", true);
  $('#' + product_id).trigger('click');

  update_summary();
});


function get_product_by_id(product_id) {
  return $(`.product-item[data-product-id=${product_id}]`).data('product-data');
}

function get_currency_code() {
  return $(`.product-item-outer`).first().data('currency-code');
}

function get_quantity_for_product_id(product_id) {
  return parseInt($('#quantity-selector-' + product_id).val());
}


function set_product_price(selected_variant, product_id) {
  // let price = selected_variant['price'];
  // let compareAtPrice = selected_variant['compare_at_price'];

  let productElement = document.querySelector(`[id="${product_id}"]`);
  // let price = productElement.getAttribute('data-price');
  let compareAtPrice = productElement.getAttribute('data-compare-price');

  let productVariants = productElement.getAttribute('data-variants');
  productVariants = productVariants.replace(/'/g, '"');
  productVariants = JSON.parse(productVariants);

  // console.log('product json:', productVariants);
  // console.log('selected_variant id', selected_variant.id)

  // Find the matching variant by selected_variant
  let selectedVariantPrice = null;

  productVariants.forEach(variant => {
    if (variant.variant_id == selected_variant.id) {
      selectedVariantPrice = variant.variant_price;
    }
  });

  let price = selectedVariantPrice

  let currency_code = get_currency_code();
  let priceFormatted = '$' + (price / 100).toFixed(2) + ` ${currency_code}`;
  let compareAtPriceFormatted = '$' + (compareAtPrice / 100).toFixed(2) + ` ${currency_code}`;

  let product_quantity = get_quantity_for_product_id(product_id);
  $('#price-' + product_id).text(priceFormatted);

  if (compareAtPrice > price) {
    $('#compare-at-price-' + product_id).text(compareAtPriceFormatted);
  } else {
    // This will only happen when one variant is on sale and another is not
    $('#compare-at-price-' + product_id).text('');
  }
}


function get_selected_variant(product, product_id) {
  var selectedValues = get_current_options(product_id);
  var variants = product['variants'];
  var found = false;

  variants.forEach(function (variant) {
    var satisfied = true;

    selectedValues.forEach(function (option) {
      if (satisfied) {
        satisfied = (option.value === variant[option.index]);
      }
    });

    if (satisfied) {
      found = variant;
    }
  });

  return found || null;
};


function get_current_options(product_id) {
  let single_option_selectors = $(`.pp-option-selector[data-product-id=${product_id}]`);

  var current_options = single_option_selectors.toArray().map(function (element) {
    var $element = $(element),
      type = $element.attr('type'),
      index = $element.attr('data-option-index');

    if (type === 'radio' || type === 'checkbox') {
      if ($element[0].checked) {
        return { value: $element.val(), index: index };
      } else {
        return false;
      }
    } else {
      return { value: $element.val(), index: index };
    }
  });

  // remove any unchecked input values if using radio buttons or checkboxes

  return current_options.filter(function (item) {
    return item;
  });
};


// Add selected items to cart
$('body').on('click', '#pp-add-to-cart-button', async function () {
  // Make sure mods/vin are filled out if applicable
  let vin_input_exists = $('#vehicle-vin-input').length > 0;
  // let mods_input_exists = $('#vehicle-mods-input').length > 0;

  if (vin_input_exists) {
    let vin_input = $('#vehicle-vin-input').val() || '';
    if (vin_input == '') {
      alert('Please enter your VIN');
      $('#vehicle-vin-input').addClass('error-input');
      return;
    }
  }
  $('#vehicle-vin-input').removeClass('error-input');

  // if (mods_input_exists) {
  //   let mods_input = $('#vehicle-mods-input').val() || '';
  //   if (mods_input == '') {
  //     alert('Please enter your vehicle mods');
  //     $('#vehicle-mods-input').addClass('error-input');
  //     return;
  //   }
  // }
  // $('#vehicle-mods-input').removeClass('error-input');

  let variant_id_quantities = get_selected_variant_ids_and_quantities();
  let fu_res = await add_variants_to_cart(variant_id_quantities);
  update_summary();
  handleCartUpdates();
});


async function add_variants_to_cart(variant_id_quantities) {
  let items = [];
  let first_item = true;

  for (const [variant_id, data] of Object.entries(variant_id_quantities)) {
    let item = {
      id: variant_id,
      quantity: data.quantity
    };

    // Initialize properties if needed
    let properties = {};

    // **Include the core_id as a line item property if it exists**
    if (data.core_id) {
      properties['_core_id'] = data.core_id;
    }

    console.log('data', data);

    // **Add SKU and MFT SKU properties if they exist**
    if (data.sku) {
      properties['Part Number'] = data.sku;
    }
    if (data.mft_part_number) {
      properties['Mft Part Number'] = data.mft_part_number;
    }

    // **Add VIN, mods, and other info to the first item only**
    if (first_item) {
      let vin = $('#vehicle-vin-input').val() || '';
      let mods = $('#vehicle-mods-input').val() || '';
      let notes = $('#vehicle-notes-input').val() || '';

      // **Add these properties to the properties object**
      Object.assign(properties, {
        VIN: vin,
        Mods: mods,
        Notes: notes,
        PowerPackage: 'True'
      });

      first_item = false;
    }

    // **Assign properties to item if there are any**
    if (Object.keys(properties).length > 0) {
      item.properties = properties;
    }

    items.push(item);
  }


  let addToCartButton = $('#pp-add-to-cart-button');
  addToCartButton.attr('disabled', 'disabled');
  addToCartButton.attr('aria-busy', 'true');
  addToCartButton.text('Adding items...');

  let fu_res = await $.ajax({
    method: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { items }
  }).then(async function (response) {
    let cartContent = await fetch('/cart.js').then(async (response2) => {
      let res_cart_content = await response2.json();
      return res_cart_content;
    });

    // Close the modal if it's open
    const modal = document.querySelector('#pp-modal')
    if (modal && modal.hasAttribute('open')) {
      modal.close();
    }

    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
      bubbles: true
    }));

    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
    }));

    addToCartButton.removeAttr('disabled');

    return cartContent;
  })
    .catch(function (error) {
      // If there is an error while adding (usually if all products are added to the cart), we temporarily
      // display the message from Shopify, and then revert to the original message after 2 seconds
      var errorMessage = error.responseJSON['description'];
      document.documentElement.dispatchEvent(new CustomEvent("on:cart:error", {
        bubbles: true,
        detail: {
          error: errorMessage
        }
      })
      );
    });

  return fu_res;
}


// Show more description
document.querySelectorAll('.pp-show-more').forEach(function (showMoreBtn) {
  showMoreBtn.addEventListener('click', function () {
    // Find the closest product item info and toggle the description class
    var productInfo = this.closest('.product-item__info');
    var description = productInfo.querySelector('.pp-description');
    description.classList.toggle('pp-description-short');

    // Toggle button text based on the class
    if (description.classList.contains('pp-description-short')) {
      this.textContent = 'Show more';
    } else {
      this.textContent = 'Show less';
    }

    // Resize the Flickity container
    // $('.pp-container').flickity('resize');
  });
});

function show_selected_products() {
  // Reset text of all select buttons
  $('input[type=radio].pp-product-select + label > span[data-type=message]').text('Add to Package' + dot);
  $('input[type=radio].pp-product-select:disabled + label').text('Unavailable');

  // Remove outline on all products
  $('.product-item').removeClass('product-is-selected');

  // Show all categories (categories with no visible products will be hidden in a few steps)
  $('.pp-category').each(function () {
    $(this).show();
  });

  // Show all products (ones that need to be hidden will be hidden in a few steps)
  $('.product-item-outer').each(function () {
    $(this).show();
  });


  $('input[type=radio].pp-product-select:checked').each(function () {

    // Set text of selected products
    let labelId = $(this).attr("id");
    if (labelId.includes('-none')) {
      $("label[for='" + labelId + "']").text('None');
    } else {
      $("label[for='" + labelId + "'] > span[data-type=message]").text(selectedText);
      // $('.pp-container').flickity('resize');
    }


    // Apply css to selected products
    $('#product-item-' + labelId).addClass('product-is-selected');


    // Hide products based on hidden_product_ids
    let hidden_product_ids = String($(this).data('hidden-product-ids')).split(',');

    hidden_product_ids.forEach(function (product_id) {
      let product = $('#product-item-outer-' + product_id);
      product.hide();
    });
  });


  // Disable categories that don't have any visible products
  $('.pp-category').each(function () {
    let has_visible_products = false;
    $(this).removeClass('disabled-category');

    $(this).find('.product-item-outer').each(function () {
      let is_visible = $(this).is(":visible");
      if (is_visible) { has_visible_products = true; }
    });

    if (!has_visible_products) {
      // $(this).hide();
      $(this).addClass('disabled-category');
    }
  });
}

function get_selected_variant_ids_and_quantities() {
  // Get variant ids of all selected items (does not include hidden products)
  let variant_id_quantities = {};

  $('.pp-product-select:checked').each(function () {
    let product_id = $(this).attr("id");
    let category = '#pp-category-' + $(this).attr("name");

    // Don't add this product if it's hidden
    if (product_is_hidden(product_id)) {
      return;
    }

    // Don't need to do anything if user has selected No Thanks option
    if (product_id.includes('-none')) {
      return;
    }

    let core_id = $(this).attr('data-core-id');
    let sku = $(this).attr('data-sku');
    let mftPartNumber = $(this).attr('data-mft-part-number');
    let product = get_product_by_id(product_id);
    let variant = get_selected_variant(product, product_id);
    let product_quantity = get_quantity_for_product_id(product_id);

    if (core_id) {
      console.log('core id', core_id);
    }

    // **Modify the structure to include core_id, sku, and mft_part_number**
    variant_id_quantities[variant['id']] = {
      quantity: product_quantity,
      core_id: core_id, // This will be undefined if core_id is not present
      sku: sku, // This will be undefined if sku is not present
      mft_part_number: mftPartNumber // This will be undefined if mft_part_number is not present
    };
  });

  return variant_id_quantities;
}


// function get_selected_variant_ids_and_quantities() {
//   // Get variant ids of all selected items (does not include hidden products)
//   let variant_id_quantities = {};

//   $('.pp-product-select:checked').each(function() {
//     let product_id = $(this).attr("id");
// 	let category = '#pp-category-' + $(this).attr("name");

//     // Don't add this product if it's hidden
//     if (product_is_hidden(product_id)) {
//       return;
//     }

//     // Don't need to do anything if user has selected No Thanks option
//     if (product_id.includes('-none')) {
//       return;
//     }

//     let core_id = $(this).attr('data-core-id');
//     let product = get_product_by_id(product_id);
//     let variant = get_selected_variant(product, product_id);
//     let product_quantity = get_quantity_for_product_id(product_id);

//     if (core_id) {
//       console.log('core id', core_id)
//     }

//     variant_id_quantities[variant['id']] = product_quantity;
//   });

//   return variant_id_quantities;
// }


function update_summary() {
  $('.pp-summary').html('');

  let totalPrice = 0;
  let numItems = 0;
  let currency_code = get_currency_code();

  $('input[type=radio].pp-product-select:checked').each(function () {

    // Don't need to do anything if user has selected "none" for a product
    let product_id = $(this).attr("id");
    if (product_id.includes('-none')) {
      return;
    }

    // Don't add this product if it's hidden
    if (product_is_hidden(product_id)) {
      return;
    }


    let title = $('#title-' + product_id).text();


    // Show variant name if applicable
    let product = get_product_by_id(product_id);
    let variant = get_selected_variant(product, product_id);
    if (variant) {
      let variant_name = variant['title'];
      if (variant_name && variant_name != 'Default Title') {
        title += ' (' + variant_name + ')';
      }
    }


    let priceFormatted = $('#price-' + product_id).text();
    // console.log('priceFormatted', priceFormatted)
    let quantity = get_quantity_for_product_id(product_id);
    let has_core_deposit = $(`.product-item[data-product-id=${product_id}]`).data('has-core-deposit');
    let core_deposit_price_formatted = '';

    if (has_core_deposit) {
      let core_tag = $(`.product-item[data-product-id=${product_id}]`).data('core-deposit-tag');
      // core_deposit_price_formatted = core_tag.split(':')[1];
      core_deposit_price_formatted = core_tag;
      // console.log('core_tag:', core_tag)
      // console.log('core_price:', core_deposit_price_formatted)
    }

    // Create summary item
    let summaryItem = '<div class="pp-summary-item">';
    summaryItem += '<b>' + title + '</b>';
    summaryItem += '<br>';

    if (quantity > 1) {
      summaryItem += quantity.toString() + " x " + priceFormatted;
    } else {
      summaryItem += priceFormatted;
    }

    if (has_core_deposit) {
      summaryItem += '<br>';
      summaryItem += `Refundable core deposit: ${quantity} x $${core_deposit_price_formatted}. <a href="https://www.dirtydieselcustom.ca/pages/core-charges" target="_blank"><u>Learn more</u>.</a>`;
    }
    summaryItem += '</div>';



    $('.pp-summary').append(summaryItem);

    let price = priceFormatted.replace(` ${currency_code}`, '');
    price = price.replace('$', '');
    price = price.replace(',', '');
    price = parseFloat(price);

    if (has_core_deposit) {
      // let core_price = core_deposit_price_formatted.replace(` ${currency_code}`, '');
      let core_price = core_deposit_price_formatted;
      // core_price = core_price.replace('$', '');
      // core_price = core_price.replace(',', '');
      core_price = parseFloat(core_price);
      totalPrice += core_price * quantity;
    }

    totalPrice += price * quantity;
    numItems++;
  });

  $('.pp-summary').append('<p><b>Total</b>: $' + totalPrice.toFixed(2) + ` ${currency_code}</p>`);
  $('#pp-add-to-cart-button').text('Add (' + numItems + ') items to cart');
}


function product_is_hidden(product_id) {
  return !$(`#product-item-outer-${product_id}`).is(":visible");
}


function set_all_prices() {
  // The product.price is not always set to the price of the first variant for some reason, so this corrects that weird shopify quirk
  $('input[type=radio].pp-product-select').each(function () {
    let product_id = $(this).attr('id');


    if (product_id.includes('-none')) {
      return; // No Thanks products don't have prices
    }

    let product = get_product_by_id(product_id);
    let variant = get_selected_variant(product, product_id);

    // Skip unavailable products
    if (product.available == false) {
      return;
    }

    set_product_price(variant, product_id);
  });
}


function update_image_for_product(productId, imageId) {
  let images = $('.images-for-' + productId);

  let hasVariantImages = true;
  if ($('#variant-selector-' + productId).css('display') == 'none') {
    hasVariantImages = false;
  }

  // If there's only 1 image or this product doesn't have unique images for each variant, then we don't need to change the image
  if (images.length == 1 || !hasVariantImages) {
    return;
  }


  // Only show image for selected variant
  images.each(function () {
    let image = $(this);
    image.hide();

    if (image.data('image-id') == imageId) {
      image.show();
    }
  });
}


function set_all_images() {
  // This method exists so we can set each image to the correct one by default on page-load
  $('input[type="radio"].pp-option-selector:checked').each(function () {
    let option = $(this);
    let productId = option.data('product-id');
    let imageId = option.data('image-id');

    updateImageForProduct(productId, imageId);
  });
}


function hide_unnecessary_show_more() {
  $('.pp-show-more').each(function () {

    let pp_description = $(this).closest('.product-item__info').find('.pp-description');
    if (pp_description.height() < 100) {
      $(pp_description).removeClass('pp-description-short');
      $(this).hide();
    }
  });
}



function scroll_to_top_of_pp_container() {
  let scrollTo = document.querySelector('.pp-container');
  const headerElement = document.querySelector('#shopify-section-header');

  if (!scrollTo) {
    scrollTo = document.querySelector('#pp-summary-container.is-selected');
  }

  // Get the header height from the CSS variable
  const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;

  // Calculate the scroll position
  const scrollPosition = scrollTo.getBoundingClientRect().top + window.scrollY - headerHeight - 25;

  // Smooth scroll to the position
  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth'
  });
}

// function scroll_to_top_of_pp_container() {
//   let scroll_to = $('.pp-category.is-selected');
//   let header_element = $('#shopify-section-header');

//   if (scroll_to.length == 0) {
//     scroll_to = $('#pp-summary-container.is-selected');
//   }

//   $('html,body').animate({scrollTop: scroll_to.offset().top - header_element.height() - 25});
// }


// Select first product in each category
$('.pp-category').each(function () {
  $('input[type=radio].pp-product-select:first', this).attr('checked', true);
  $('input[type=radio].pp-product-select:first + label > span[data-type=message]', this).text(selectedText);
  // $('.pp-container').flickity('resize');
});


set_all_prices();
set_all_images();

show_selected_products();
update_summary();
hide_unnecessary_show_more();

document.addEventListener('DOMContentLoaded', function () {
  // Query key elements with guard clauses to ensure they exist
  const pageWrapper = document.querySelector('.page__content-wrapper');
  if (!pageWrapper) return;

  const pageContainer = pageWrapper.querySelector('.container');
  const swiper = pageWrapper.querySelector('.box');
  if (!swiper || !pageContainer) return;

  const wrapper = swiper.querySelector('.pp-container');
  if (!wrapper) return;

  /**
   * Initialize the swiper hierarchy by adding required classes.
   */
  function setupSwiper() {
    swiper.classList.add('swiper');
    wrapper.classList.add('swiper-wrapper');

    // Add the "swiper-slide" class to each child of the wrapper.
    Array.from(wrapper.children).forEach(slide => {
      slide.classList.add('swiper-slide')

      const slideDescription = slide.querySelector('.pp-category-description')
      const slideContent = slide.querySelector('.list-products')
      const slideContentWrapper = document.createElement('div')
      slideContentWrapper.classList.add('pp-category-content')

      // Only append elements if they exist
      if (slideDescription) {
        slideContentWrapper.appendChild(slideDescription)
      }
      if (slideContent) {
        slideContentWrapper.appendChild(slideContent)
      }
      slide.appendChild(slideContentWrapper)
    });
  }

  /**
   * Update button classes by removing old classes and adding new ones.
   */
  function updateButtonClasses() {
    const buttons = swiper.querySelectorAll('.button.button--primary');
    buttons.forEach(button => {
      button.classList.remove('button', 'button--primary');
      button.classList.add('btn', 'btn--primary');
    });
  }

  /**
   * Move the modal opener and the swiper element into the modal structure.
   */
  function moveModalContent() {
    const modalButton = document.querySelector('#pp-modal-opener');
    const modal = document.querySelector('#pp-modal');

    if (modalButton && modal) {
      // Apply a color scheme to the page container.
      pageContainer.classList.add('color-scheme--1');

      // Insert modalButton after the page title.
      const pageTitle = pageContainer.querySelector('.page__title');
      if (pageTitle) {
        pageTitle.insertAdjacentElement('afterend', modalButton);
      }

      // Append the swiper element into the modal content.
      const modalContent = modal.querySelector('.modal__content');
      if (modalContent) {
        modalContent.appendChild(swiper);
      }
    }
  }

  // Execute swiper and modal functions.
  setupSwiper();
  updateButtonClasses();
  moveModalContent();

  const ppSwiper = new Swiper('.box.swiper', {
    loop: false,
    slidesPerView: 'auto',
    allowTouchMove: false,
    watchOverflow: true,
    centeredSlidesBounds: true,
    updateOnWindowResize: true,
    // autoHeight: true,
    breakpoints: {
      768: {},
    },
    navigation: {
      nextEl: '.pp-swiper-btn-next',
      prevEl: '.pp-swiper-btn-prev',
    },
  });
});